<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #header>
      <Row :gutter="10" style="width: 100%">
        <Col
          span="8"
          class="file-div"
          v-for="item in filesList"
          :key="item.type"
        >
          <div class="flex-div" @click="uploadClick(item.type)">
            <template v-if="!item.src">
              <Upload
                ref="upload"
                accept="image/jpg, image/jpeg, image/png"
                :before-upload="handleUpload"
                action=""
                :data="uploadData"
              >
                <Button
                  :disabled="!$hasPermission(326)"
                  icon="ios-cloud-upload-outline"
                >
                  {{ $t("updateFile") }}{{ $t(item.name) }}
                </Button>
              </Upload>
            </template>
            <template v-else>
              <img :src="item.src" />
              <div class="demo-upload-list-cover">
                <Button type="primary" size="large" @click="preview(item.src)">
                  <Icon type="ios-eye-outline"></Icon>
                  {{ $t("preview") }}
                </Button>
                <Button
                  type="error"
                  size="large"
                  :disabled="!$hasPermission(375)"
                  @click="deleteClick(item.type)"
                >
                  <Icon type="ios-trash-outline"></Icon>
                  {{ $t("delete") }}
                </Button>
              </div>
            </template>
          </div>
        </Col>
      </Row>
    </template>
    <template #header_bottom v-if="fit">
      <cTable
        ref="child"
        :fields="child.fields"
        :footer="child.footer"
        :config="child.config"
      />
    </template>
  </cTable>
</template>

<script>
import {
  getContract,
  updateFlie,
  add,
  del,
  update,
  getDetails,
  delBL,
  getContractParams,
  getContractFile,
  delContractFile
} from "@/api/user/contract";

import cTable from "@/base/common/index";

export default {
  inject: ["$page"],
  components: {
    cTable
  },
  props: {
    rows: {
      type: Object
    }
  },
  methods: {
    uploadClick(type) {
      this.uploadData = {
        type: type
      };
    },
    handleUpload(file) {
      this.upload(file);
      return false;
    },
    upload(file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", this.uploadData.type);
      formData.append("client_id", this.rows.id);
      updateFlie(formData).then(res => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg,
          duration: res.data.status ? 2 : 5
        });
        if (res.data.status) {
          this.filesList.map(item => {
            if (item.type == this.uploadData.type) {
              item.src = res.data.payload.src;
            }
            return;
          });
        }
      });
    },
    preview(src) {
      window.open(src, "_blank");
    },
    deleteClick(type) {
      this.$Modal.confirm({
        title: this.$t("delete"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          delBL(type, this.rows.id).then(res => {
            this.$Message[res.data.status ? "success" : "error"]({
              background: true,
              content: res.data.msg,
              duration: res.data.status ? 2 : 5
            });
            if (res.data.status) {
              this.filesList.map(item => {
                if (item.type == type) {
                  item.src = "";
                }
                return;
              });
            }
          });
        }
      });
    },
    open() {
      this.$refs["table"].getModal("add").open(
        {
          client_id: this.rows.id
        },
        function() {
          this.setTitle(
            this.$t("b2bClient") +
              "(" +
              this.$page.config.rows.account +
              ")" +
              this.$t("add") +
              this.$t("bindContract")
          );
        }
      );
    }
  },
  data() {
    return {
      child: {
        config: {
          slot: "div",
          resize: false,
          isGetList: true,
          height: 250
        },
        footer: {
          show: () => false
        },
        fields: [
          {
            name: () => this.$tz("线上,合同协议"),
            key: "name",
            minWidth: 110
          },
          {
            name: () => this.$t("operation"),
            type: "btns",
            width: 220,
            fixed: "right",
            list: [
              {
                name: this.$tz("查看"),
                type: "show",
                fnName: "show",
                bind: {
                  type: "primary"
                }
              }
            ],
            methods: {
              show({ row }) {
                window.open(row.url, "_blank");
              }
            }
          }
        ]
      },
      uploadData: {},
      fit: false,
      filesList: [
        {
          type: 1,
          text: "business_license",
          name: "business_license",
          src: ""
        },
        {
          type: 3,
          text: "idcard_z",
          name: "FrontIDCard",
          src: ""
        },
        {
          type: 4,
          text: "idcard_f",
          name: "ReverseIDCard",
          src: ""
        }
      ],
      methods: {
        list: p => {
          p.client_id = this.config.rows.id;
          return getContract(p);
        },
        add,
        del,
        update,
        getDetails,
        getContractParams,
        getContractFile,
        delContractFile,
        beforeHandleList: ({ data }) => {
          this.filesList.map(item => {
            item.src = data[item.text];
            return;
          });
          if (data.fit_contract.length) {
            this.config.height = 250;
            this.fit = true;
            this.$nextTick(() => {
              this.$refs["child"].list = data.fit_contract;
            });
          }
          return data.rows;
        }
      },
      config: {
        slot: "div",
        height: 500,
        resize: false,
        rows: this.rows
      },
      modals: {
        add: {
          footer: {
            show: () => true
          },
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods(data.id ? "update" : "add", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              start_time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date"
                }
              ],
              end_time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date"
                }
              ],
              remark: [
                {
                  required: true,
                  message: "Please enter remark",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { type: 24 },
            { title: 24 },
            { has_paper: 24 },
            { mail_note: 24 },
            { start_time: 24 },
            { end_time: 24 },
            { remark: 24 }
          ],
          fields: [
            {
              key: "type",
              name: () => this.$t("contract_type"),
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contract_type"),
              options: [],
              config: {
                label: "title",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getContractParams")
                  ).payload.agreement;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "title",
              name: () => this.$t("contract_title"),
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contract_title"),
              options: [],
              config: {
                label: "title",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getContractParams")
                  ).payload.header;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "has_paper",
              name: () => this.$t("has_paper"),
              component: "Radio",
              placeholder: () => this.$t("select") + this.$t("exlType"),
              bind: {
                border: true
              },
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              default: 0
            },
            {
              key: "mail_note",
              name: () => this.$t("mail_note"),
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("mail_note")
            },
            {
              key: "start_time",
              name: () => this.$t("contract_start_time"),
              component: "DatePicker",
              placeholder: () =>
                this.$t("select") + this.$t("start") + this.$t("date"),
              bind: {
                style: {
                  width: "100%"
                }
              },
              disabledDate: true
            },
            {
              key: "end_time",
              name: () => this.$t("contract_end_time"),
              component: "DatePicker",
              placeholder: () =>
                this.$t("select") + this.$t("contract_end_time"),
              bind: {
                style: {
                  width: "100%"
                }
              },
              disabledDate: true
            },
            {
              key: "remark",
              name: () => this.$t("contract_remark"),
              placeholder: () => this.$t("enter") + this.$t("contract_remark"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        filesLog: {
          footer: {
            show: () => false
          },
          methods: {},
          config: {
            modalBind: {
              width: 700,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".pdf, .word,.docx"
              },
              id: 326,
              methods: {
                beforeUpload: ({ file }) => {
                  let files = [];
                  files.push(file);
                  let formData = new FormData();
                  for (var i = 0; i < files.length; i++) {
                    formData.append("file[]", files[i]); // 文件对象
                  }
                  formData.append("type", 2);
                  formData.append("client_id", this.config.rows.id);
                  formData.append("contract_id", this.config.rows.contract_id);
                  updateFlie(formData).then(res => {
                    this.$Message[res.data.status ? "success" : "error"]({
                      background: true,
                      content: res.data.msg,
                      duration: res.data.status ? 2 : 5
                    });
                    if (res.data.status) {
                      this.$refs["table"]
                        .handleRequestMethods("getContractFile", {
                          contract_id: this.config.rows.contract_id
                        })
                        .then(res => {
                          this.$refs["table"].getModal("filesLog").list =
                            res.payload.rows;
                        });
                    }
                  });
                  return false;
                }
              }
            }
          ],
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("file_name"),
                key: "name"
              },
              {
                name: () => this.$t("operation"),
                width: 130,
                type: "btns",
                list: [
                  {
                    name: () => this.$t("preview"),
                    type: "preview",
                    fnName: "preview",
                    bind: {
                      type: "primary",
                      icon: "ios-eye-outline"
                    }
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    bind: {
                      icon: "md-trash"
                    }
                  }
                ],
                methods: {
                  preview: ({ row }) => {
                    let src = this.$globalUrl + row.src;
                    if (row && row.is_doc) {
                      window.open(
                        // "https://view.officeapps.live.com/op/view.aspx?src=" +
                          src,
                        "_blank"
                      );
                    } else {
                      window.open(src, "_blank");
                    }
                  },
                  delete({ row, rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods(
                          "delContractFile",
                          row.id
                        ).then(res => {
                          this.$Message[res.status ? "success" : "error"]({
                            background: true,
                            content: res.msg,
                            duration: res.status ? 2 : 5
                          });
                          this.getModal("filesLog").list.splice(rowIndex, 1);
                        });
                      }
                    });
                  }
                }
              }
            ]
          }
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [],
        btns: {}
      },
      fields: [
        {
          name: () => this.$t("contract_title"),
          key: "titleMapping",
          align: "left",
          minWidth: 200,
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        {
          name: () => this.$t("contract_type"),
          key: "typeMapping",
          align: "left",
          minWidth: 100,
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        {
          name: () => this.$t("has_paper"),
          key: "has_paper",
          width: 110,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$t("mail_note"),
          key: "mail_note"
        },
        {
          name: () => this.$t("contract_start_time"),
          key: "start_time",
          width: 120
        },
        {
          name: () => this.$t("contract_end_time"),
          key: "end_time",
          width: 120
        },
        {
          name: () => this.$t("contract_remark"),
          key: "remark"
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: this.$tz("查看"),
              type: "show",
              fnName: "show",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("copy"),
              type: "copy",
              fnName: "copy",
              bind: {
                type: "primary"
              },
              id: 99
            },
            {
              name: () => this.$t("contract_src"),
              type: "openLog",
              fnName: "openLog",
              bind: {
                type: "warning"
              },
              id: 329
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 100
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 101
            }
          ],

          methods: {
            show({ row }) {
              window.open(row.url, "_blank");
            },
            openLog({ row }) {
              this.config.rows.contract_id = row.id;
              this.handleRequestMethods("getContractFile", {
                contract_id: row.id
              }).then(res => {
                this.getModal("filesLog").open({}, function() {
                  this.list = res.payload.rows;
                  this.setTitle(
                    this.$t("b2bClient") +
                      "(" +
                      this.$page.config.rows.account +
                      ")" +
                      this.$t("contract_src")
                  );
                });
              });
            },
            copy({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                res => {
                  res.payload.id = "";
                  this.getModal("add").open(res.payload, function() {
                    this.setTitle(
                      this.$t("b2bClient") +
                        "(" +
                        this.$page.config.rows.account +
                        ")" +
                        this.$t("add") +
                        this.$t("bindContract")
                    );
                  });
                }
              );
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                res => {
                  this.getModal("add").open(res.payload, function() {
                    this.setTitle(
                      this.$t("b2bClient") +
                        this.$page.config.rows.account +
                        ")" +
                        this.$t("update") +
                        this.$t("contract_src")
                    );
                  });
                }
              );
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style scoped lang="less">
.file-div {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.file-div .flex-div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 1px solid #e8eaec;
  position: relative;
  height: 200px;
  overflow: hidden;
  width: 100%;
}
.file-div .flex-div img {
  max-height: 100%;
  max-width: 100%;
  background-size: cover;
}
.demo-upload-list-cover {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  cursor: pointer;
}
.flex-div:hover .demo-upload-list-cover {
  display: flex;
  justify-content: center;
  align-items: center;
}
.demo-upload-list-cover button:last-child {
  margin-left: 10px;
}
.file-list {
  display: flex;
  align-items: center;
  height: 30px;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaec;
}
</style>
